
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20.25 20.25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.181 0A3.194 3.194 0 000 3.18v2.315a3.194 3.194 0 003.182 3.182h13.886a3.194 3.194 0 003.182-3.182V3.18A3.194 3.194 0 0017.067 0zm0 1.735h13.886c.816 0 1.447.63 1.447 1.446v2.315c0 .815-.631 1.446-1.447 1.446H3.181c-.815 0-1.446-.63-1.446-1.446V3.18c0-.815.63-1.446 1.446-1.446zm0 9.836A3.194 3.194 0 000 14.753v2.314a3.194 3.194 0 003.182 3.182h13.886a3.194 3.194 0 003.182-3.182v-2.314a3.194 3.194 0 00-3.182-3.182zm0 1.735h13.886c.816 0 1.447.631 1.447 1.447v2.314c0 .816-.631 1.447-1.447 1.447H3.181a1.426 1.426 0 01-1.446-1.447v-2.314c0-.816.63-1.447 1.446-1.447z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    